/* eslint linebreak-style: ["error", "windows"] */
/* eslint object-curly-newline: ["error", "always"] */
/* eslint-env es6 */
import axios from 'axios';
import {
  endpoint,
} from '../utils/utils';
import {
  getusertoken,
  getUserPidm,
} from './login';

export const materiacursos = async (usuario, periodo) => {
  const resp = axios.get(`${endpoint}/proyeccion/${getUserPidm()}/${periodo}`, getusertoken());
  return resp;
};

export const cursos = async (usuario, matcursos, periodo) => {
  const resp = axios.get(`${endpoint}/proyeccion/${getUserPidm()}/cursos/${matcursos}/${periodo}`, getusertoken());
  return resp;
};
